import { z } from 'zod';

/* Config */
export const AdminConfigSchema = z.object({
  sparkCooldownSec: z.number().int().min(5).max(3600),
  circlePostCooldownSec: z.number().int().min(1).max(600),
  glowMaxMinutes: z.number().int().min(30).max(360),
  signupsOpen: z.boolean(),
  maintenanceMode: z.boolean(),
  blockedWords: z.array(z.string().max(40)).max(500),
});
export type AdminConfig = z.infer<typeof AdminConfigSchema>;

export const AdminConfigResponseSchema = z.object({ config: AdminConfigSchema });
export type AdminConfigResponse = z.infer<typeof AdminConfigResponseSchema>;
